import { MenuItemType } from '@utils/types'
import { EditableDescription, EditableTitle, WImage } from '@components/atoms'
import styles from './ApplicazioneCard.module.sass'

interface Props {
  item?: MenuItemType
  className?: string
  editMode?: boolean
}

const ApplicazioneCard = (props: Props) => {
  const { className = '', item = undefined, editMode = false } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WImage
        className={styles.image}
        alt={item?.imageAlt}
        src={item.image}
        maxWidth={410}
        maxHeight={242}
        objectFit="cover"
      />
      <div className={styles.main}>
        <EditableTitle
          title={item.name}
          variant="h3"
          editMode={editMode}
          className={styles.title}
        />
        <EditableDescription
          description={item?.description}
          editMode={editMode}
          className={styles.description}
        />
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ApplicazioneCard
